import React from "react";
import {
  FaLock,
  FaUserSlash,
  FaKey,
  FaMobileAlt,
  FaShieldAlt,
  FaGlobe,
  FaServer,
  FaShieldVirus,
} from "react-icons/fa";

function SecurityWLE() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="assets/img/thumb/our_services_section_image.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-35 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Security of our White Label Exchange Service
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="">
                    <div className="container">
                      <div className="services-style-four-items">
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaLock size={40} />
                          </div>
                          <h4>Data Encryption</h4>
                          <p>
                            Ensure the confidentiality and integrity of
                            sensitive user information by employing advanced
                            encryption protocols, both for data in transit and
                            at rest, preventing unauthorized access and data
                            breaches.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaUserSlash size={40} />
                          </div>
                          <h4>Jail Login</h4>
                          <p>
                            Protect user accounts from brute force attacks by
                            automatically locking login attempts after a set
                            number of failed attempts, effectively preventing
                            unauthorized access through repeated guessing.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaKey size={40} />
                          </div>
                          <h4>Token-Based HTTP Authentication</h4>
                          <p>
                            Secure API communications by utilizing token-based
                            HTTP authentication, ensuring that only verified
                            clients can access the platform’s services, and
                            reducing the risk of session hijacking or
                            unauthorized access.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaMobileAlt size={40} />
                          </div>
                          <h4>Two-Factor Authentication (2FA)</h4>
                          <p>
                            Add an extra layer of security to user accounts by
                            requiring a second verification step, such as a code
                            sent to the user’s mobile device, making it
                            significantly harder for attackers to compromise
                            accounts.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaShieldAlt size={40} />
                          </div>
                          <h4>Anti-Denial of Service (DoS) Protection</h4>
                          <p>
                            Implement Anti-DoS measures to prevent malicious
                            actors from overwhelming the exchange with excessive
                            traffic, ensuring uninterrupted service and
                            protecting the platform from downtime or slowdowns.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaGlobe size={40} />
                          </div>
                          <h4>
                            Cross-Site Request Forgery (CSRF) Security Mechanism
                          </h4>
                          <p>
                            Token-based security mechanism defends exchange from
                            unwanted actions from an authenticated user.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaServer size={40} />
                          </div>
                          <h4>Server-Side Request Forgery (SSRF) Protection</h4>
                          <p>
                            Safeguard your platform from SSRF attacks by
                            filtering and validating incoming requests, ensuring
                            that attackers cannot exploit server vulnerabilities
                            to access internal systems or sensitive information.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaShieldVirus size={40} />
                          </div>
                          <h4>Anti-Denial of Service (Dos)</h4>
                          <p>
                            Anti-Dos secures the ecosystems when a susceptible
                            number of requests is recognized by the trading
                            engine.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SecurityWLE;
